import { render, staticRenderFns } from "./fingerfoodPage.vue?vue&type=template&id=1c9fff6e&scoped=true&"
import script from "./fingerfoodPage.vue?vue&type=script&lang=js&"
export * from "./fingerfoodPage.vue?vue&type=script&lang=js&"
import style0 from "./fingerfoodPage.vue?vue&type=style&index=0&id=1c9fff6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9fff6e",
  null
  
)

export default component.exports